export default __webpack_public_path__ + "dbe649a99022c4c0ec4f0883c0e2cf68.png";